import * as React from 'react'
import * as Lodash from 'lodash/fp'
import { Box } from '@design/pt-ui'

import AddCreative from '../CreativeCard/AddCreative'
import { Project } from '../../interfaces/entities/project'
import { Formatset } from '../../interfaces/entities/formatset'
import { Creative, CreativeAction } from '../../interfaces/entities/creative'
import SortableCards from '../CreativeCard/SortableCards'
import { User } from '../../interfaces/entities/user'

interface ICreativeGridProps {
  formatset: Formatset
  user: User
  project: Project
  doCreativeAction: (creative: Creative, action: CreativeAction) => void
}

interface ICreativeGridState {
  creatives: Creative[]
}

function CreativesGrid(props: ICreativeGridProps) {
  const [state, setState] = React.useState<ICreativeGridState>({
    creatives: props.formatset.creatives || [],
  })

  React.useEffect(() => {
    setState((state) => ({ ...state, creatives: props.formatset.creatives }))
  }, [props.formatset.creatives])

  const { formatset } = props

  /**
   * Depending of the platform, recommended number may be maximum or minimum
   *
   * @param formatset
   */
  function getWarn(formatset: Formatset) {
    let warn = false
    switch (formatset.type) {
      case 'facebook':
        warn =
          formatset.creatives.length >=
          Lodash.getOr(4, ['data', 'recommended_number'], formatset)
        break
      case 'performance_advertising':
        warn =
          formatset.creatives.length <
          Lodash.getOr(2, ['data', 'recommended_number'], formatset)
        break
    }
    return warn
  }

  return (
    <Box
      className="cp-formatset-creatives-container"
      sx={{
        display: 'flex',
        justifyContent: 'start',
        flexWrap: 'wrap',
      }}>
      <SortableCards
        creatives={
          props.user.groups.includes('client')
            ? state.creatives.map((creative) => {
                return {
                  ...creative,
                  possibleActions: creative.possibleActions.filter(
                    (action) => action.name !== 'send',
                  ),
                }
              })
            : state.creatives
        }
        recommendedNoOfCreatives={Lodash.getOr(
          4,
          ['data', 'recommended_number'],
          formatset,
        )}
        formatSetType={formatset.type}
        doCreativeAction={props.doCreativeAction}
      />
      {props.project.status.name === 'archived' || props.formatset.invalid ? (
        ''
      ) : (
        <Box sx={{ margin: '15px 8.7px' }}>
          <AddCreative
            warn={getWarn(formatset)}
            formats={formatset.creativeFormats}
            project={props.project}
            formatsetId={formatset.id}
            formatsetName={formatset.name}
            formatsetPlatform={formatset.type}
            formatsetData={formatset.data}
          />
        </Box>
      )}
    </Box>
  )
}

export default CreativesGrid
